import { createSlice } from '@reduxjs/toolkit'

const {
  actions: {
    getAllCasinoProvidersStart,
    getAllCasinoProvidersSuccess,
    getAllCasinoProvidersFailure,
    createCasinoProviderStart,
    createCasinoProviderComplete,
    updateCasinoProviderStart,
    updateCasinoProviderComplete,
    getAllCasinoGamesStart,
    getAllCasinoGamesSuccess,
    getAllCasinoGamesFailure,
    createCasinoGameStart,
    createCasinoGameComplete,
    updateCasinoGameStart,
    updateCasinoGameComplete,
    resetCasinoGameStart,
    resetCasinoGameSuccess,
    updateCasinoStatusStart,
    updateCasinoStatusComplete,
    getSuperAdminAggregatorsStart,
    getSuperAdminAggregatorsSuccess,
    getSuperAdminAggregatorsFailure,
    createSuperAdminAggregatorStart,
    createSuperAdminAggregatorComplete,
    updateSuperAdminAggregatorStatusStart,
    updateSuperAdminAggregatorStatusComplete,
    getSuperAdminGameCategoryStart,
    getSuperAdminGameCategorySuccess,
    getSuperAdminGameCategoryFailure,
    getSuperAdminGameSubCategoryStart,
    getSuperAdminGameSubCategorySuccess,
    getSuperAdminGameSubCategoryFailure,
    getSuperAdminPopularGameStart,
    getSuperAdminPopularGameSuccess,
    getSuperAdminPopularGameFailure,
    getSuperAdminNewGameStart,
    getSuperAdminNewGameSuccess,
    getSuperAdminNewGameFailure,
    handleSuperAdminPopularGameStart,
    updateSACasinoGamesStatusStart,
    updateSACasinoGamesStatusComplete,
    getAllSAProvidersStart,
    getAllSAProvidersSuccess,
    getAllSAProvidersFailure,
    getFreeSpinGamesStart,
    getFreeSpinGamesSuccess,
    getFreeSpinGamesFailure,
    updateReorderGamesStart,
    updateReorderGamesSuccess,
    updateReorderGamesFailure,
    deleteCasinoSubCategoriesStart,
    deleteCasinoSubCategoriesSuccess,
    deleteCasinoSubCategoriesFailure,
    updateCasinoStart,
    updateCasinoComplete,
    createCasinoComplete,
    createCasinoStart,
    addGamesToSubCategoryStart,
    addGamesToSubCategoryComplete,
    updateCategoryReOrderStart,
    updateCategoryReOrderComplete,
    updateStatusStart,
    updateStatusSuccess,
    updateStatusFailure,
    updateGameThumbnailURLStart,
    updateGameThumbnailURLComplete,
    updateGameThumbnailURLFailure,
    deleteCategoryStart,
    deleteCategorySuccess,
    deleteCategoryFailure,


    // add casino game category 

    addCasinogameCategoryStart,
    addCasinogameCategorySuccess,
    addCasinogameCategoryFailure,

    getCasinoGamesCategoryStart,
    getCasinoGamesCategorySuccess,
    getCasinoGamesCategoryFailure,

    getCasinoGamesCategoryCountStart,
    getCasinoGamesCategoryCountSuccess,
    getCasinoGamesCategoryCountFailure,

    deleteCasinoGamesCategoryStart,
    deleteCasinoGamesCategorySuccess,
    deleteCasinoGamesCategoryFailure,


  },
  reducer
} = createSlice({
  name: 'fetchCasinoData',
  initialState: {
    loading: false,
    casinoProvidersData: null,
    casinoGamesData: null,
    casinogameLoading: false,
    aggregators: null,
    gameCategory: null,
    gameSubCategory: null,
    allProviders: null,
    popularGames: null,
    deleteCategoryData: null,
    casinoGameCategorydata: "",
    loadingAddCategory: false,
    CategoryGamesData: "",
    loadingCategorygames: false,
    loadingGamesCount: false,
    gamesCountData: null,
    loadingDeleteCategoryGame: false,
    deleteCategoryGameData: "",
  },
  reducers: {
    getAllCasinoProvidersStart: (state) => ({
      ...state,
      loading: true
    }),
    getAllCasinoProvidersSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      casinoProvidersData: payload
    }),
    getAllCasinoProvidersFailure: (state) => ({
      ...state,
      loading: false
    }),
    getAllCasinoGamesStart: (state) => ({
      ...state,
      loading: true,
      casinogameLoading: true
    }),
    addGamesToSubCategoryStart: (state) => ({
      ...state,
      loading: true
    }),
    addGamesToSubCategoryComplete: (state) => ({
      ...state,
      loading: false
    }),
    resetCasinoGameStart: (state) => ({
      ...state,
      loading: true
    }),
    resetCasinoGameSuccess: (state) => ({
      ...state,
      loading: false,
      casinogameLoading: false,
      casinoGamesData: null
    }),
    getAllCasinoGamesSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      casinogameLoading: false,
      casinoGamesData: payload
    }),
    getAllCasinoGamesFailure: (state, { payload }) => ({
      ...state,
      loading: false
    }),
    createCasinoGameStart: (state) => ({
      ...state,
      loading: true
    }),
    createCasinoGameComplete: (state) => ({
      ...state,
      loading: false
    }),
    createCasinoProviderStart: (state) => ({
      ...state,
      loading: true
    }),
    createCasinoStart: (state) => ({
      ...state,
      loading: true
    }),
    createCasinoComplete: (state) => ({
      ...state,
      loading: false
    }),
    createCasinoProviderComplete: (state) => ({
      ...state,
      loading: false
    }),
    updateCasinoGameStart: (state) => ({
      ...state,
      loading: true
    }),
    updateCasinoGameComplete: (state) => ({
      ...state,
      loading: false
    }),
    updateCasinoProviderStart: (state) => ({
      ...state,
      loading: true
    }),
    updateCasinoProviderComplete: (state) => ({
      ...state,
      loading: false
    }),
    updateCasinoStatusStart: (state) => ({
      ...state,
      loading: true
    }),
    updateCasinoStatusComplete: (state) => ({
      ...state,
      loading: false
    }),
    getSuperAdminAggregatorsStart: (state) => ({
      ...state,
      loading: true
    }),
    getSuperAdminAggregatorsSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      aggregators: payload
    }),
    getSuperAdminAggregatorsFailure: (state) => ({
      ...state,
      loading: false
    }),
    createSuperAdminAggregatorStart: (state) => ({
      ...state,
      loading: true
    }),
    createSuperAdminAggregatorComplete: (state) => ({
      ...state,
      loading: false
    }),
    updateSuperAdminAggregatorStatusStart: (state) => ({
      ...state,
      loading: true
    }),
    updateSuperAdminAggregatorStatusComplete: (state) => ({
      ...state,
      loading: false
    }),
    getSuperAdminGameCategoryStart: (state) => ({
      ...state,
      loading: true
    }),
    getSuperAdminGameCategorySuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      gameCategory: payload
    }),
    getSuperAdminGameCategoryFailure: (state) => ({
      ...state,
      loading: false
    }),
    getSuperAdminGameSubCategoryStart: (state) => ({
      ...state,
      loading: true
    }),
    getSuperAdminGameSubCategorySuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      gameSubCategory: payload
    }),
    getSuperAdminGameSubCategoryFailure: (state, { payload }) => ({
      ...state,
      loading: false
    }),
    getSuperAdminNewGameStart: (state) => ({
      ...state,
      loading: true
    }),
    getSuperAdminNewGameSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      popularGames: payload
    }),
    getSuperAdminNewGameFailure: (state) => ({
      ...state,
      loading: false
    }),
    getSuperAdminPopularGameStart: (state) => ({
      ...state,
      loading: true
    }),
    getSuperAdminPopularGameSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      popularGames: payload
    }),
    getSuperAdminPopularGameFailure: (state) => ({
      ...state,
      loading: false
    }),
    handleSuperAdminPopularGameStart: (state) => ({
      ...state,
      loading: true
    }),
    updateSACasinoGamesStatusStart: (state) => ({
      ...state,
      loading: true
    }),
    updateSACasinoGamesStatusComplete: (state) => ({
      ...state,
      loading: false
    }),
    deleteCasinoSubCategoriesStart: (state) => ({
      ...state,
      loading: true
    }),
    deleteCasinoSubCategoriesSuccess: (state) => ({
      ...state,
      loading: false
    }),
    deleteCasinoSubCategoriesFailure: (state) => ({
      ...state,
      loading: false
    }),
    updateCasinoComplete: (state) => ({
      ...state,
      loading: false
    }),
    updateCasinoStart: (state) => ({
      ...state,
      loading: false
    }),

    getAllSAProvidersStart: (state) => ({
      ...state,
      loading: true
    }),
    getAllSAProvidersSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      allProviders: payload
    }),
    getAllSAProvidersFailure: (state, { payload }) => ({
      ...state,
      loading: false
    }),
    getFreeSpinGamesStart: (state) => ({
      ...state,
      loading: true
    }),
    getFreeSpinGamesSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      casinoGamesData: payload
    }),
    getFreeSpinGamesFailure: (state) => ({
      ...state,
      loading: false
    }),
    updateReorderGamesStart: (state) => ({
      ...state,
      loading: true
    }),
    updateReorderGamesSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      reorderGames: payload
    }),
    updateReorderGamesFailure: (state) => ({
      ...state,
      loading: false
    }),
    updateCategoryReOrderStart: (state) => ({
      ...state,
      loading: true
    }),
    updateCategoryReOrderComplete: (state) => ({
      ...state,
      loading: false
    }),
    updateStatusStart: (state) => ({
      ...state,
      isGetSportsLoading: true
    }),
    updateStatusSuccess: (state) => ({
      ...state,
      isGetSportsLoading: false
    }),
    updateStatusFailure: (state) => ({
      ...state,
      isGetSportsLoading: false
    }),
    updateGameThumbnailURLStart: (state) => ({
      ...state,
      loading: true
    }),
    updateGameThumbnailURLComplete: (state) => ({
      ...state,
      loading: false
    }),
    updateGameThumbnailURLFailure: (state) => ({
      ...state,
      loading: false
    }),
    // delete category
    deleteCategoryStart: (state) => ({
      ...state,
      loading: true,
      deleteCategoryData: null
    }),
    deleteCategorySuccess: (state, action) => ({
      ...state,
      loading: false,
      deleteCategoryData: action?.payload
    }),
    deleteCategoryFailure: (state) => ({
      ...state,
      loading: false,
      deleteCategoryData: null
    }),


    addCasinogameCategoryStart: (state) => ({
      ...state,
      loading: true,
      casinoGameCategorydata: "",
      loadingAddCategory: true,
    }),
    addCasinogameCategorySuccess: (state, payload) => ({
      ...state,
      loading: false,
      casinoGameCategorydata: payload,
      loadingAddCategory: false,
    }),
    addCasinogameCategoryFailure: (state) => ({
      ...state,
      loading: false,
      casinoGameCategorydata: "",
      loadingAddCategory: false,
    }),

    // get super admin casino games

    getCasinoGamesCategoryStart: (state) => ({
      ...state,
      loading: true,
      CategoryGamesData: "",
      loadingCategorygames: true,
    }),
    getCasinoGamesCategorySuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      CategoryGamesData: payload,
      loadingCategorygames: false,
    }),
    getCasinoGamesCategoryFailure: (state) => ({
      ...state,
      loading: false,
      CategoryGamesData: "",
      loadingCategorygames: false,
    }),

    getCasinoGamesCategoryCountStart: (state) => ({
      ...state,
      loading: true,
      loadingGamesCount: true,
      gamesCountData: null
    }),
    getCasinoGamesCategoryCountSuccess: (state, { payload }) => ({
      ...state,
      loading: false,


      loadingGamesCount: false,
      gamesCountData: payload


    }),
    getCasinoGamesCategoryCountFailure: (state) => ({
      ...state,
      loading: false,
      loadingGamesCount: false,
      gamesCountData: ""
    }),

    deleteCasinoGamesCategoryStart: (state) => ({
      ...state,
      loading: true,
      loadingDeleteCategoryGame: true,
      deleteCategoryGameData: null
    }),
    deleteCasinoGamesCategorySuccess: (state, { payload }) => ({
      ...state,
      loading: false,


      loadingDeleteCategoryGame: false,
      deleteCategoryGameData: payload


    }),
    deleteCasinoGamesCategoryFailure: (state) => ({
      ...state,
      loading: false,
      loadingDeleteCategoryGame: false,
      deleteCategoryGameData: ""
    }),


  }
})

export default reducer

export {
  getAllCasinoProvidersStart,
  getAllCasinoProvidersSuccess,
  getAllCasinoProvidersFailure,
  createCasinoProviderStart,
  createCasinoStart,
  createCasinoComplete,
  createCasinoProviderComplete,
  updateCasinoProviderStart,
  updateCasinoProviderComplete,
  getAllCasinoGamesStart,
  addGamesToSubCategoryStart,
  addGamesToSubCategoryComplete,
  getAllCasinoGamesSuccess,
  getAllCasinoGamesFailure,
  createCasinoGameStart,
  createCasinoGameComplete,
  updateCasinoGameStart,
  updateCasinoGameComplete,
  resetCasinoGameStart,
  resetCasinoGameSuccess,
  updateCasinoStatusStart,
  updateCasinoStatusComplete,
  getSuperAdminAggregatorsStart,
  getSuperAdminAggregatorsSuccess,
  getSuperAdminAggregatorsFailure,
  createSuperAdminAggregatorStart,
  createSuperAdminAggregatorComplete,
  updateSuperAdminAggregatorStatusStart,
  updateSuperAdminAggregatorStatusComplete,
  getSuperAdminGameCategoryStart,
  getSuperAdminGameCategorySuccess,
  getSuperAdminGameCategoryFailure,
  getSuperAdminGameSubCategoryStart,
  getSuperAdminGameSubCategorySuccess,
  getSuperAdminGameSubCategoryFailure,
  getSuperAdminNewGameStart,
  getSuperAdminNewGameSuccess,
  getSuperAdminNewGameFailure,
  getSuperAdminPopularGameStart,
  getSuperAdminPopularGameSuccess,
  getSuperAdminPopularGameFailure,
  handleSuperAdminPopularGameStart,
  updateSACasinoGamesStatusStart,
  updateSACasinoGamesStatusComplete,
  getAllSAProvidersStart,
  getAllSAProvidersSuccess,
  getAllSAProvidersFailure,
  getFreeSpinGamesStart,
  getFreeSpinGamesSuccess,
  getFreeSpinGamesFailure,
  updateReorderGamesStart,
  updateReorderGamesSuccess,
  updateReorderGamesFailure,
  deleteCasinoSubCategoriesStart,
  deleteCasinoSubCategoriesSuccess,
  deleteCasinoSubCategoriesFailure,
  updateCasinoStart,
  updateCasinoComplete,
  updateCategoryReOrderStart,
  updateCategoryReOrderComplete,
  updateStatusStart,
  updateStatusSuccess,
  updateStatusFailure,
  updateGameThumbnailURLStart,
  updateGameThumbnailURLComplete,
  updateGameThumbnailURLFailure,
  deleteCategoryStart,
  deleteCategorySuccess,
  deleteCategoryFailure,
  addCasinogameCategoryStart,
  addCasinogameCategorySuccess,
  addCasinogameCategoryFailure,

  getCasinoGamesCategoryStart,
  getCasinoGamesCategorySuccess,
  getCasinoGamesCategoryFailure,

  getCasinoGamesCategoryCountStart,
  getCasinoGamesCategoryCountSuccess,
  getCasinoGamesCategoryCountFailure,

  deleteCasinoGamesCategoryStart,
  deleteCasinoGamesCategorySuccess,
  deleteCasinoGamesCategoryFailure,

}
